/**
 * 애플리케이션의 전역 설정을 관리하는 클래스
 */
class AppConfig {
  private static instance: AppConfig;

  // 환경 설정
  private readonly env: string;
  private readonly isDevelopment: boolean;
  private readonly isProduction: boolean;

  // 서버 설정
  private readonly debugServerUrl: string = "http://localhost:3500";
  private readonly productionServerUrl: string =
    "https://jayshin-server.duckdns.org";

  private constructor() {
    this.env = process.env.REACT_APP_ENV || "development";
    this.isDevelopment = this.env === "development";
    this.isProduction = this.env === "production";
  }

  public static getInstance(): AppConfig {
    if (!AppConfig.instance) {
      AppConfig.instance = new AppConfig();
    }
    return AppConfig.instance;
  }

  // 환경 관련 getter
  public getEnv(): string {
    return this.env;
  }

  public isDevMode(): boolean {
    return this.isDevelopment;
  }

  public isProdMode(): boolean {
    return this.isProduction;
  }

  // 서버 URL 관련 getter
  public getServerUrl(): string {
    return this.isDevelopment ? this.debugServerUrl : this.productionServerUrl;
  }

  // Analytics 관련 getter
  public isAnalyticsEnabled(): boolean {
    return this.isProduction;
  }

  public isAnalyticsDebug(): boolean {
    return this.isDevelopment;
  }

  // 디버그 모드 (전체적인 디버그 상태)
  public isDebugMode(): boolean {
    return this.isDevelopment;
  }
}

export default AppConfig;
